module.exports = __webpack_public_path__ + "img/wheelbackgroundfinal.da7d46c9.png";